import { isNil } from 'ramda';
import type { PinnedAppsMap } from '~/components/page/Widget/state/pinnedApps';

const itemIsPinned = (id: string, pinnedApps: PinnedAppsMap) =>
  !isNil(pinnedApps[id]);

export default itemIsPinned;
